export default class PoznamkaEditModalCtrl{
  constructor($uibModalInstance, poziadavka, PoziadavkaService, uzivatelia){
    this.dialog = $uibModalInstance;
    this.PoziadavkaService = PoziadavkaService;
    this.poziadavka = poziadavka;
    this.zodpovednyOptions = [{label:"Ponechať", value: null}].concat(uzivatelia.map(u => ({label: u.meno, value: {id: u.id}})));

    this.formError = null;
    this.nextStep = null;

    this.result = {
      poznamka: {
        poziadavka: poziadavka,
        stavChanged: null,
        zodpovednyChanged: null,
        externa: false
      },
    };

    this.result.poznamka.prilohy = this.result.poznamka.prilohy || [];
  }

  ok(){
    if (!this.result.poznamka.text) {
      this.formError = 'Text ponámky je povinný.';
      return;
    }


    this.dialog.close(this.result);
  }

  cancel(){
    this.dialog.dismiss('cancel')
  }
}


// WEBPACK FOOTER //
// ./src/customer-portal/poziadavky/PoznamkaEditModalCtrl.js